export default "__VITE_ASSET__9cd0c771__"